import { render, staticRenderFns } from "./form-number.vue?vue&type=template&id=257b013e&"
import script from "./form-number.vue?vue&type=script&lang=js&"
export * from "./form-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports